export default function PageHeader({ title, description, action }) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between stagger-in">
      <div className="max-w-2xl">
        <h1 className="font-head text-3xl md:text-4xl font-bold text-foreground leading-none">{title}</h1>
        {description && <p className="mt-3 text-muted-foreground leading-relaxed">{description}</p>}
      </div>
      {action}
    </div>
  );
}
